import React from 'react';
import * as S from './UpgradeSubscriptionButton.styled';
export const UpgradeSubscriptionButton = ({ fullWidth = false, label = 'Upgrade to Pro', type = 'button', size = 'medium', onClick, }) => {
    return (React.createElement(S.Container, { "$fullWidth": fullWidth, size: size, type: type, onClick: onClick }, label));
};
